import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { PatternLayer, patternLight } from "./patterns";

const CARDS = [
  {
    to: "/collections/loose-lab-diamonds",
    tag: "Lab-Grown",
    title: "Loose Lab Diamonds",
    image: "/assets/loose-lab-diamonds.jpg",
    alt: "Loose certified lab-grown diamonds in round, oval, emerald and princess cuts",
    testid: "loose-stones-card-lab",
  },
  {
    to: "/collections/loose-stones",
    tag: "Natural & Gemstones",
    title: "Loose Gemstones",
    image: "/assets/loose-gemstones.jpg",
    alt: "Loose colored gemstones — ruby, sapphire, emerald, amethyst and more",
    testid: "loose-stones-card-gems",
  },
];

export const LooseStones = () => {
  return (
    <section className="relative overflow-hidden bg-white border-y border-[#E8DCC4] py-12 lg:py-16" data-testid="loose-stones">
      <PatternLayer pattern={patternLight} />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-10">
        <Reveal className="lg:w-72 shrink-0">
          <Eyebrow>By the Carat</Eyebrow>
          <h2 className="font-display text-2xl md:text-3xl font-light tracking-tight text-neutral-900" data-testid="loose-stones-heading">
            Start with <span className="text-[#C9A227]">the stone</span>
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-neutral-600">
            Pick the stone first — we build the piece around it, sized and set for you.
          </p>
        </Reveal>
        <div className="flex-1 grid sm:grid-cols-2 gap-4 lg:gap-5">
          {CARDS.map((c, i) => (
            <Reveal key={c.to} delay={0.06 * i}>
              <Link
                to={c.to}
                data-testid={c.testid}
                className="group block bg-[#FDFBF7] border border-[#E8DCC4] rounded-sm overflow-hidden hover:border-[#C9A227] hover:-translate-y-0.5 hover:shadow-[0_16px_32px_rgb(201,162,39,0.10)] transition-[border-color,transform,box-shadow] duration-300"
              >
                <div className="h-40 sm:h-44 overflow-hidden">
                  <img
                    src={c.image}
                    alt={c.alt}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                  />
                </div>
                <div className="px-5 py-4 flex items-center justify-between gap-3">
                  <div className="min-w-0">
                    <span className="text-[10px] uppercase tracking-[0.18em] text-[#C9A227] font-semibold">{c.tag}</span>
                    <h3 className="font-display text-base text-neutral-900 mt-0.5 truncate">{c.title}</h3>
                  </div>
                  <span className="shrink-0 inline-flex items-center gap-1.5 text-xs font-semibold text-[#A8871B]">
                    Browse stones <ArrowRight size={12} strokeWidth={1.5} className="group-hover:translate-x-1 transition-transform duration-300" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
